import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import * as lodash from 'lodash'
import { AirbnbHost2GuestReviewCategories, airbnbHost2GuestReviewCategoryTags } from '@tokeet-frontend/channels'
import { AbstractControl, FormBuilder, Validators, FormGroup } from '@angular/forms'
import { ReviewCategoryRatingForAI } from '@tokeet-frontend/reviews'
import { SaveForm } from '@tokeet-frontend/tv3-platform'
import { Store } from '@ngrx/store'
import { RatingBooking } from '@tv3/store/inquiry/inquiry-fields.actions'

@Component({
  selector: 'app-booking-rating-dialog',
  templateUrl: './booking-rating-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./booking-rating-dialog.component.scss'],
})
export class BookingRatingDialogComponent implements OnInit {
  categoryRatings = this.fb.array([])

  categories = Object.values(AirbnbHost2GuestReviewCategories)
  tags = lodash.groupBy(airbnbHost2GuestReviewCategoryTags, (t) => t.category)
  constructor(
    public dialogRef: MatDialogRef<BookingRatingDialogComponent>,
    private fb: FormBuilder,
    private store: Store<any>,
    @Inject(MAT_DIALOG_DATA) public data: { inquiry: Inquiry; defaultRating: number }
  ) {}

  ngOnInit() {
    const bookingRatingsByCategory = lodash.keyBy(this.data.inquiry.ratings, (t) => t.type)
    lodash.forEach(this.categories, (c) =>
      this.addCategoryRating({
        ...bookingRatingsByCategory[c],
        type: c,
        stars: bookingRatingsByCategory[c]?.stars || this.data.defaultRating,
      })
    )
  }

  addCategoryRating(data?: ReviewCategoryRatingForAI) {
    const item = this.fb.group({
      type: [data?.type, [Validators.required]],
      stars: [data?.stars, [Validators.required]],
      comment: [data?.comment || '', []],
      tags: [data?.tags || []],
    })
    item.get('type').disable()
    this.categoryRatings.push(item)
  }

  onRate(form: FormGroup, v: number) {
    form.patchValue({ stars: v })
  }

  @SaveForm()
  onSave(form: AbstractControl) {
    const ratings = this.categoryRatings.getRawValue() as ReviewCategoryRatingForAI[]
    this.store.dispatch(RatingBooking({ ratings, inquiryId: this.data.inquiry.id }))
    this.close()
  }

  close() {
    this.dialogRef.close()
  }
}
